/* src/app/forms/formview/form-field-properties/form-field-properties-detail/form-field-properties-detail.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 10px;
}
.dialog-title {
  color: var(--tem-ink);
  font-size: var(--tem-fs-xl);
  font-weight: 600;
  margin-bottom: var(--tem-space-2);
}
.dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  margin: 0;
  padding: 6px;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--tem-space-2);
}
.panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: var(--tem-space-2);
}
.panel-title {
  font-weight: 600;
  color: var(--tem-ink);
}
.panel-desc {
  color: var(--tem-muted);
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
}
.data-info {
  display: flex;
  width: 100%;
  padding: 10px;
  flex-direction: column-reverse;
}
.data-name {
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
.action-buttons {
  padding-bottom: 20px;
}
.props-grid {
  display: grid;
  gap: 5px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  padding: var(--tem-space-2);
  align-items: center;
}
.props-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}
.props-grid-6 {
  grid-template-columns: repeat(6, 1fr);
}
.info-title {
  font-size: 100%;
  font-weight: 500;
  color: var(--tem-ink);
}
.info-desc {
  font-size: 100%;
  color: var(--tem-muted);
  display: flex;
  align-items: center;
  min-width: 0;
}
.info-desc button {
  font-size: 80%;
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.full-select {
  width: 100%;
}
.ajuste-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.right-confort-pad {
  padding-right: 4px;
}
/*# sourceMappingURL=form-field-properties-detail.component.css.map */
